(function () {
  // Collaborators carousel — prev/next + drag-to-scroll
  var trackWraps = document.querySelectorAll('.collab-track-wrap');
  var cardWidth = 260; // card + gap

  trackWraps.forEach(function (trackWrap) {
    var sectionId = trackWrap.id.replace('carousel-track-', '');
    var prevBtn = document.getElementById('carousel-prev-' + sectionId);
    var nextBtn = document.getElementById('carousel-next-' + sectionId);

    if (!prevBtn || !nextBtn) return;

    prevBtn.addEventListener('click', function () {
      trackWrap.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      trackWrap.scrollBy({ left: cardWidth, behavior: 'smooth' });
    });

    var dragging = false, startX, scrollL;

    trackWrap.addEventListener('mousedown', function (e) {
      dragging = true;
      startX = e.pageX - trackWrap.offsetLeft;
      scrollL = trackWrap.scrollLeft;
    });

    trackWrap.addEventListener('mouseleave', function () {
      dragging = false;
    });

    trackWrap.addEventListener('mouseup', function () {
      dragging = false;
    });

    trackWrap.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      trackWrap.scrollLeft = scrollL - (e.pageX - trackWrap.offsetLeft - startX);
    });
  });
})();
